import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "@/i18n/LanguageContext";
import Reveal from "@/components/site/Reveal";
import { RevealTextInstant } from "@/components/site/RevealText";
import { INDUSTRIES } from "@/lib/data";

export default function IndustriesPage() {
  const { t } = useLang();
  return (
    <div data-testid="page-industries" className="pt-32 md:pt-40">
      <section className="mx-auto max-w-[1440px] px-6 md:px-10 pb-16 md:pb-24">
        <div className="grid grid-cols-12 gap-6 mb-10">
          <div className="col-span-12 md:col-span-3 az-tag"><span className="az-tag__dot" /><span>{t.industries.kicker}</span></div>
          <div className="col-span-12 md:col-span-3 md:col-start-10 md:text-right font-mono text-[10px] tracking-widest uppercase text-[#86868B]">
            06 / {t.industries.kicker}
          </div>
        </div>
        <RevealTextInstant
          as="h1"
          lines={[t.industries.title]}
          className="font-serif tracking-tighter leading-[0.94] text-[11vw] md:text-[6.5vw] lg:text-[6rem]"
          lineClassName="block"
        />
        <div className="mt-10 grid grid-cols-12 gap-8">
          <div className="col-span-12 md:col-span-7 md:col-start-6">
            <Reveal delay={0.15}>
              <p className="font-sans text-lg md:text-xl leading-relaxed text-[#86868B] max-w-[56ch]">
                {t.industries.lead}
              </p>
            </Reveal>
          </div>
        </div>
      </section>

      <section className="bg-white border-t border-[#E5E5EA]">
        <div className="mx-auto max-w-[1440px] px-6 md:px-10">
          {INDUSTRIES.map((ind, i) => {
            const item = t.industries.items[ind.id];
            const reverse = i % 2 === 1;
            return (
              <Reveal key={ind.id} delay={i * 0.03}>
                <article
                  className={[
                    "grid grid-cols-12 gap-6 md:gap-10 py-16 md:py-28 border-b border-[#E5E5EA] items-center",
                  ].join(" ")}
                  data-testid={`industry-${ind.id}`}
                >
                  <div className={`col-span-12 md:col-span-6 ${reverse ? "md:order-2" : ""}`}>
                    <div className="relative aspect-[16/11] overflow-hidden bg-[#0A0A0A]">
                      <img src={ind.image + "?auto=format&fit=crop&w=1600&q=80"} alt={item.title} className="absolute inset-0 w-full h-full object-cover" loading="lazy" />
                      <div className="absolute bottom-4 left-4 right-4 flex justify-between text-white font-mono text-[10px] tracking-widest uppercase">
                        <span>{String(i + 1).padStart(2, "0")} / {t.common.section}</span>
                        <span>AZ · Studio</span>
                      </div>
                    </div>
                  </div>
                  <div className={`col-span-12 md:col-span-5 ${reverse ? "md:order-1" : "md:col-start-8"}`}>
                    <span className="font-mono text-[10px] tracking-widest uppercase text-[#86868B]">{String(i + 1).padStart(2, "0")}</span>
                    <h2 className="mt-4 font-serif text-3xl md:text-5xl tracking-tight leading-[1.05]">{item.title}</h2>
                    <p className="mt-6 font-sans text-base md:text-lg leading-relaxed text-[#86868B] max-w-[50ch]">{item.body}</p>
                  </div>
                </article>
              </Reveal>
            );
          })}
        </div>
      </section>

      <section className="py-24 md:py-32 bg-[#F5F5F7] border-t border-[#E5E5EA]">
        <div className="mx-auto max-w-[1440px] px-6 md:px-10 flex flex-col md:flex-row items-start md:items-end justify-between gap-8">
          <h3 className="font-serif text-4xl md:text-6xl tracking-tighter max-w-[22ch] leading-[0.98]">
            {t.home.contactTitle}
          </h3>
          <Link to="/contact" className="az-btn" data-testid="industries-contact-cta">
            <span>{t.nav.cta}</span>
            <span className="az-btn__arrow" aria-hidden="true">→</span>
          </Link>
        </div>
      </section>
    </div>
  );
}
